"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DefaultNatural = /** @class */ (function (_super) {
    __extends(DefaultNatural, _super);
    function DefaultNatural() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultNatural.prototype.render = function () {
        return (React.createElement("g", { id: 'Eyebrow/Natural/Default-Natural', fillOpacity: '0.599999964' },
            React.createElement("path", { d: 'M26.0390934,6.21012364 C20.2775554,6.98346216 11.2929313,12.0052479 12.04426,17.8178111 C12.0689481,18.0080543 12.3567302,18.0673468 12.4809077,17.9084937 C14.9674041,14.7203351 34.1927973,10.0365481 41.1942673,11.0147151 C41.8350523,11.1044465 42.2580662,10.4430343 41.8210501,10.0302067 C38.0765663,6.49485426 31.2003792,5.51224825 26.0390934,6.21012364', id: 'Eyebrow', transform: 'translate(27.000000, 12.000000) rotate(5.000000) translate(-27.000000, -12.000000) ' }),
            React.createElement("path", { d: 'M85.0390934,6.21012364 C79.2775554,6.98346216 70.2929313,12.0052479 71.04426,17.8178111 C71.0689481,18.0080543 71.3567302,18.0673468 71.4809077,17.9084937 C73.9674041,14.7203351 93.1927973,10.0365481 100.194267,11.0147151 C100.835052,11.1044465 101.258066,10.4430343 100.82105,10.0302067 C97.0765663,6.49485426 90.2003792,5.51224825 85.0390934,6.21012364', id: 'Eyebrow', transform: 'translate(86.000000, 12.000000) scale(-1, 1) rotate(5.000000) translate(-86.000000, -12.000000) ' })));
    };
    DefaultNatural.optionValue = 'DefaultNatural';
    return DefaultNatural;
}(React.Component));
exports.default = DefaultNatural;
